<template>
    <div>
      <div @mouseleave="hideHeaderBasket" v-if="items.length" class="h_basket_none active basketline-container" :class="{ 'ajax_processed' : ajaxProcessed, }" >
        <span>
            <a @mouseover="showHeaderBasket" @click="onClick($event)" :href="url" class="basketline__basket-link" >
                {{ items.length }} {{ getPluralize(items.length, 'товар', 'товара', 'товаров') }}
                {{ !hidePrices ? `(${total} &#8381;)` : '' }}
            </a>
        </span>
        <div class="basketline-details">
            <div class="basketline-details__header">Список покупок</div>
            <div class="basketline-details__content">
                <form method="post" :action="formUrl" name="basket_form" class="basket_form">
                    <div v-for="group in groups" class="basketline-details__category" :class="'basketline-details__category--' + group" >
                        <div v-for="item in items.filter(o => o.group == group)" class="basketline-details__item basket_product" :class="'basketline-details__item--'+item.productId" >
                            <div class="basketline-details__item__pic">
                                <a :href="item.url" ><img :src="item.img" alt="" /></a>
                            </div>
                            <div class="basketline-details__item__name">
                                <a :href="item.url">{{ item.name }}</a>
                            </div>
                            <div class="basketline-details__item__count">
                                <quantity v-model="item.quantity" :max-quantity="+item.storeAmount || 99999" :product-id="+item.productId" :quantity="+item.quantity" @change="itemQuantityChanged(item)" ></quantity>
                            </div>
                            <div class="basketline-details__item__sum" v-html="!hidePrices ? item.sumFormatted : ''" ></div>
                            <div class="basketline-details__item__delete">
                                <a href="javascript:void(0);" @click="deleteItem(item.cartId)" class="basketline-details__item__delete-link">удалить</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="basketline-details__footer">
                <template v-if="!hidePrices" >
                    Итого: {{ total }} &#8381;
                </template>
                <a @click="onClick($event)" :href="url" class="btn btn_red">К списку покупок</a>
            </div>
        </div>
      </div>
      <div v-else class="h_basket_none basketline-container">
        <span>Список покупок пуст</span>
      </div>
    </div>
</template>

<script>
export default {
    name: 'Basketline',
    props : {
        hidePrices : {
            type : Boolean,
            default : false,
        },
        url : {
            type : String,
            default : '',
        },
        formUrl : {
            type : String,
            default : '',
        },
        cartTotal : {
            type : String,
            default : '',
        },
        cartItems : {
            type : Array,
            default : [],
        },
    },
    computed : {
        isOrdersDisabled : () => vxCommonStore.state.isOrdersDisabled,
        items : () => vxCommonStore.state.cartItems,
        total () {
            let total = +vxCommonStore.state.cartTotal;
            if (vxCommonStore.state.cartData.tareSum) {
                total += +vxCommonStore.state.cartData.tareSum;
            }
            return +total.toFixed(2);
        },
        groups () {
            return _.map(_.uniqBy(this.items, 'group'), 'group') || [];
        },
    },
    data : () => ({
        ajaxProcessed : false,
    }),
    mounted () {
        let productIds = this.cartItems.length ? _.map(this.cartItems, item => +item.productId) : [];
        vxCommonStore.commit('setProductsInCart', productIds);
        vxCommonStore.commit('setCartItems', this.cartItems);
        vxCommonStore.commit('setCartTotal', this.cartTotal);
        // this.update(); //установливаем кол-во товаров при загрузке страницы
    },
    watch : {
        total (val, oldVal) {
        },
    },
    methods : {
        getPluralize (num, a, b, c) {
            return getPluralize(num, a, b, c);
        },
        onClick (e) {

        },
        showHeaderBasket(){
            $('body').addClass('basketline_expanded');
            window.clearTimeout(window.basketline_expanded_timer);
        },
        hideHeaderBasket(){
            window.basketline_expanded_timer = window.setTimeout(function(){
                $('body').removeClass('basketline_expanded');
            }, 100);
        },
        deleteItem (itemCartId) {
            let data = {};
            data['ajax_command'] = 'delete_cart_item';
            data['item_id'] = itemCartId;
            XPage.ajax({
                data : data,
                success : response => {
                    this.update();
                }
            });
        },
        //itemQuantityChanged (productId, quantity) {
        itemQuantityChanged (item) {
            clearTimeout(window.itemQuantityChangedTimeout);
            window.itemQuantityChangedTimeout = setTimeout(
                () => {
                    let data = {};
                    data.ajax_command = 'cart_change';
                    data.CART_ITEM = {};
                    //let item = this.items.find(o => o.productId == productId );
                    if (item) {
                        data.CART_ITEM[item.cartId] = {
                            QUANTITY : item.quantity,
                        };
                        this.ajaxProcessed = true;
                        XPage.ajax({
                            data : data,
                            success : response => {
                                this.ajaxProcessed = false;
                                this.update();
                                if (vmApp.$refs.basket) {
                                    vmApp.$refs.basket.update();
                                }
                            }
                        });
                    }
                },
                400
            );
        },
        update () {
            let data = {};
            data['ajax_command'] = 'update_basketline';
            this.ajaxProcessed = true;
            XPage.ajax({
                data : data,
                success : response => {
                    this.ajaxProcessed = false;
                    if (typeof(response.data) != 'undefined') {
                        let productIds = response.data.items.length ? _.map(response.data.items, item => +item.productId) : [];
                        vxCommonStore.commit('setProductsInCart', productIds);
                        vxCommonStore.commit('setCartItems', response.data.items);
                        vxCommonStore.commit('setCartTotal', response.data.total);
                    }
                }
            });
        },
      deleteToProductInCart(el){
        let self = this;
        let data         ={};
        data[ "ajax_command" ]= "delete_product_in_cart";
        data[ "product_id" ]     = el.productId;
        XPage.ajax({
          data    : data,
          success : response =>
            {
              if(this.$parent.$refs.basket)
                {
                  this.$parent.$refs.basket.update();
                }
              this.$emit("product-added-to-cart");
              clearTimeout(this.productAddedTimeout);
              this.productAddedTimeout=setTimeout(
                  () =>
                  {
                    self.update();
                  },
                  3000
              );
            }
        });
      },
      addToCart(el)
        {
          let self         =this;
          let data         ={};
          let arProductInfo=[];
          arProductInfo.push({
            product_id : el.productId,
            quantity   : el.quantity
          });
          data[ "ajax_command" ]="addtocart";
          data[ "PRODUCT" ]     =arProductInfo;

          XPage.ajax({
            data    : data,
            success : response =>
              {
                if(this.$parent.$refs.basket)
                  {
                    this.$parent.$refs.basket.update();
                  }
                clearTimeout(this.productAddedTimeout);
                this.productAddedTimeout=setTimeout(
                    () =>
                    {
                      self.update();
                    },
                    3000
                );
              }
          });
        },
    },
}
</script>
